// extracted by mini-css-extract-plugin
module.exports = {"head":"page_head__8rvdK","VideoList":"page_VideoList__HkkPm"};